module.exports = __webpack_public_path__ + "img/Considerate Career.9eccce7c.svg";